import { put, select, takeLatest } from 'redux-saga/effects'

import { startup as startupAction } from '@/redux/rootReducer'
import {
  selectBackgroundTasks,
  setAppReady,
  // startBackgroundCheckDownloadSpeed,
  // startBackgroundCheckUploadSpeed,
  stopBackgroundCheckDownloadSpeed,
  stopBackgroundCheckUploadSpeed,
} from '@/redux/reducers/app.reducer'

export function* startup() {
  yield put(setAppReady(true))
}

export function* startBackgroundTasks() {
  // yield put(startBackgroundCheckDownloadSpeed())
  // yield put(startBackgroundCheckUploadSpeed())
}

export function* stopBackgroundTasks() {
  const backgroundTasks: Record<string, boolean> = yield select(selectBackgroundTasks)
  if (backgroundTasks.checkDownloadSpeed) yield put(stopBackgroundCheckDownloadSpeed())
  if (backgroundTasks.checkUploadSpeed) yield put(stopBackgroundCheckUploadSpeed())
}

const watchAppSagas = [takeLatest(startupAction.type, startup)]

export default watchAppSagas
